import { render, staticRenderFns } from "./ProcessingButton.vue?vue&type=template&id=b224fcd8"
import script from "./ProcessingButton.vue?vue&type=script&lang=js"
export * from "./ProcessingButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports